<template>
	<popup ref="popup" :loading="popupLoading">
		<div slot="body">
			<el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true" label-width="80px"
				:rules="rules">
				<el-row>
					<el-col :span="8">
						<el-form-item label="手机" prop="moblie">
							<el-input v-model="formParameter.moblie" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="身份证号" prop="idno">
							<el-input v-model="formParameter.idno" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="民族" prop="mz">
							<el-input v-model="formParameter.mz" autocomplete="off" ></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8">
						<el-form-item label="姓名" prop="name">
							<el-input v-model="formParameter.name" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>

					<el-col :span="8">
						<el-form-item label="性别" prop="sex" disabled>
							<el-input v-model="formParameter.sex" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="户籍地" prop="fjaera">
							<el-input v-model="formParameter.fjaera" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				
				<el-row>
					<el-col :span="8">
						<el-form-item label="报读届" prop="bdyear">
							<el-select placeholder="请选择" :popper-append-to-body="false" v-model="formParameter.bdyear"
								@change="getSubject(1)">
								<el-option v-for="(item, index) in sbjData.year" :key="index" :label="item" :value="item"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item   label="学历层次" prop="level">
							<el-select placeholder="请选择" :popper-append-to-body="false" v-model="formParameter.level"
								@change="getSubject(2)">
								<el-option v-for="(item, index) in sbjData.levl" :key="index" :label="item" :value="item"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="专业" prop="subject" :inline="true">
							<el-select placeholder="请选择" :popper-append-to-body="false" v-model="formParameter.subject"
								@change="getSubject(3, formParameter.subject)">
								<el-option v-for="(item, index) in sbjData.sbjs" :key="index" :label="item.nm"
									:value="item.nm"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				
				</el-row>
				<el-row>
					<el-col :span="8">
						<el-form-item label="院校" prop="school" :inline="true">
							<el-select @change="getSubject2($event)" placeholder="请选择" :popper-append-to-body="false"
								v-model="formParameter.school">
								<el-option v-for="(item, index) in sbjData.school" :key="index" :label="item.nm"
									:value="item.nm"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<!-- <el-col :span="8">
						<el-form-item label="报考情况" prop="bminfo">
							<select-option-dictionary v-model="formParameter.bminfo"
								dkey="signup-bminfo"></select-option-dictionary>
						</el-form-item>
					</el-col> -->
					<el-col :span="8">
						<el-form-item label="报考缴费" prop="gntm">
							<el-date-picker v-model="formParameter.gntm"  type="datetime" placeholder="选择日期">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="推荐人" prop="tjrName">
							<el-input v-model="formParameter.tjrName" disabled  autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row>
					<el-col :span="8">
						<el-form-item label="学校代码" prop="skcode">
							<el-input v-model="formParameter.skcode" autocomplete="off" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="专业代码" prop="code">
							<el-input v-model="formParameter.code" autocomplete="off" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="类别" prop="type">
							<el-input v-model="formParameter.type" autocomplete="off" disabled></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8">
						<el-form-item label="毕业学校" prop="byschool">
							<el-input v-model="formParameter.byschool" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="毕业专业" prop="bysub">
							<el-input v-model="formParameter.bysub" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="毕业时间" prop="bytm">
							<el-date-picker v-model="formParameter.bytm" type="date" placeholder="选择日期">
							</el-date-picker>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="毕业证号" prop="byzid">
							<el-input v-model="formParameter.byzid" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="考前学历" prop="kqgrd">
							<el-input v-model="formParameter.kqgrd" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
					<!-- <el-col  :span="8">
						<el-form-item label="考试区域" prop="ksarea">
							<el-input v-model="formParameter.ksarea" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>  <el-row v-if="formParameter.id">
					<el-col   :span="8">
						<el-form-item label="网报号" prop="wbno">
							<el-input v-model="formParameter.wbno" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="密码" prop="wbpwd">
							<el-input v-model="formParameter.wbpwd" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>

					<el-col :span="8">
						<el-form-item label="报名号" prop="bmno">
							<el-input v-model="formParameter.bmno" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
			
				</el-row> 
				 <el-row>
					<el-col :span="24">
						<el-form-item label="备选考区" prop="ksarea2">
							<el-input v-model="formParameter.ksarea2" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row> 
				 <el-row>
					<el-col :span="24">
						<el-form-item label="快递地址" prop="postaera">
							<el-input v-model="formParameter.postaera" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row> 
				 <el-row>
					<el-col :span="24">
						<el-form-item label="备注" prop="remarks">
							<el-input v-model="formParameter.remarks" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row> -->
			</el-form>
		</div>
		<div slot="footer">
			<el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm()">确 定</el-button>
			<el-button @click="close">关 闭</el-button>
		</div>

	</popup>
</template>

<script>
import popup from '@/components/popup/drawerPopup.vue';
import api from '@/api/xueli/xlstudent.js';
import selectOptionDictionary from "@/components/biz/selectOptionDictionary/selectOptionDictionary.vue";
import selectUserTableDialog from "@/components/biz/selectUserTableDialog/selectUserTableDialog.vue";
import signupApi from '@/api/xueli/signup.js';

export default {
	name: 'edit',
	components: {
		popup,
		selectOptionDictionary,
		selectUserTableDialog
	},
	data() {
		return {
			disabled: false,
			popupLoading: false,
			confirmLoading: false,
			parameter: {},
			response: [],   //xlschool表的数据
			sbjData: [],    //专业备选项
			key: '',
			formParameter: {},
			listLoading: '',
			page: new this.$constant.pageObj(),
			searchParams: {},
			rules: {
				//报读届
				bdyear: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 20,
						trigger: 'blur'
					}
				],
				//姓名
				name: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 32,
						trigger: 'blur'
					}
				],
				//手机
				moblie: [
					{ required: true, message: '请输入', trigger: 'blur' },
					{ validator: this.validDh, message: '请输入正确的手机号格式', trigger: 'blur' }
				],
				//报读院校
				school: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 32,
						trigger: 'blur'
					}
				],
				//层次
				level: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 32,
						trigger: 'blur'
					}
				],
				//专业
				subject: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 32,
						trigger: 'blur'
					}
				],
				//类别
				type: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 32,
						trigger: 'blur'
					}
				],
				//户籍地
				fjaera: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 32,
						trigger: 'blur'
					}
				],
				//考试区域
				ksarea: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 32,
						trigger: 'blur'
					}
				],
				//备选考区
				ksarea2: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 32,
						trigger: 'blur'
					}
				],
				//成考加分
				plus: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 11,
						trigger: 'blur'
					}
				],
				//考前学历
				kqgrd: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 32,
						trigger: 'blur'
					}
				],
				//毕业学校
				byschool: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 32,
						trigger: 'blur'
					}
				],
				//毕业专业
				bysub: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 32,
						trigger: 'blur'
					}
				],
				//毕业时间
				bytm: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						trigger: 'blur'
					}
				],
				//毕业证号
				byzid: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 32,
						trigger: 'blur'
					}
				],
				//身份证号
				idno: [
					{ required: true, message: '请输入身份证号码', trigger: 'blur' },
					{
						validator: this.validID,
						// required: true,
						// pattern: /(^[1-9]\d{5}(((1[89]|20)\d{2}(((0[13578]|1[0-2])(0[1-9]|[12][0-9]|3[01]))|((0[469]|11)(0[1-9]|[12][0-9]|30))|(02(0[1-9]|[1][0-9]|2[0-8]))))|((((1[89]|20)(0[48]|[2468][048]|[13579][26]))|((19|20)00))0229))\d{3}(\d|X|x)$)/,
						message: '身份证格式不正确', trigger: 'blur'
					}

				],
				//性别
				sex: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 32,
						trigger: 'blur'
					}
				],
				//民族
				mz: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 32,
						trigger: 'blur'
					}
				],
		 
		 
			 
			}
		};
	},


	methods: {

		getSubject2(e) {

			let oneSk = this.sbjData.school.filter(v => (v.nm == e))

			this.formParameter.skcode = oneSk[0].code
			//this.$set(this.formParameter,"school",e)
			//   ?   $   vue-vm问题？  绑定数据的延迟性
			setTimeout(this.$forceUpdate(), 10);
		},
		//获取数据
		getSubject(level, e) {

			//1. 封装请求参数
			let param = {}

			if (level == 1) {
				param = { zsyear: this.formParameter.bdyear }
				delete this.formParameter.level
				delete this.formParameter.subject
				delete this.formParameter.school
				delete this.formParameter.skcode
				delete this.formParameter.code
				delete this.formParameter.type
			} else if (level == 2) {
				param = { level: this.formParameter.level, zsyear: this.formParameter.bdyear }
				delete this.formParameter.subject
				delete this.formParameter.school
				delete this.formParameter.skcode
				delete this.formParameter.code
				delete this.formParameter.type
			} else { //专业
				param = { level: this.formParameter.level, sbjname: this.formParameter.subject, zsyear: this.formParameter.bdyear }
				delete this.formParameter.school
				delete this.formParameter.skcode
				delete this.formParameter.code
				delete this.formParameter.type
			}

			//级联加载报读信息                   	
			api.cascadeSub(param, (response) => {
				// 通过vue的双向绑定渲染数据
				this.sbjData = response.data;
				if (!this.formParameter.bdyear) {   //控制第一级  bdyear
					this.formParameter.bdyear = this.sbjData.year[0]
					this.formParameter.level = this.sbjData.levl[0]
		 
					if (this.sbjData.sbjs) {
						this.formParameter.subject = this.sbjData.sbjs[0].nm
						this.formParameter.code = this.sbjData.sbjs[0].code
						this.formParameter.type = this.sbjData.sbjs[0].type
						if (this.sbjData.school[0]) {
							this.formParameter.school = this.sbjData.school[0].nm
							this.formParameter.skcode = this.sbjData.school[0].code
						}
					}
				} else {
					if (!this.formParameter.level) {   //控制第二级  level
						this.formParameter.level = this.sbjData.levl[0]
						if (this.sbjData.sbjs) {
							this.formParameter.subject = this.sbjData.sbjs[0].nm
							this.formParameter.code = this.sbjData.sbjs[0].code
							this.formParameter.type = this.sbjData.sbjs[0].type
							if (this.sbjData.school[0]) {
								this.formParameter.school = this.sbjData.school[0].nm
								this.formParameter.skcode = this.sbjData.school[0].code
							}
						}
					} else {
						if (!this.formParameter.subject) {   //控制第三级  subject
							if (this.sbjData.sbjs[0]) {
								this.formParameter.subject = this.sbjData.sbjs[0].nm
								this.formParameter.code = this.sbjData.sbjs[0].code
								this.formParameter.tp = this.sbjData.sbjs[0].type
								if (this.sbjData.school[0]) {
									this.formParameter.school = this.sbjData.school[0].nm
									this.formParameter.skcode = this.sbjData.school[0].code
								}
							}
						} else {
							if (level == 3) {
								let sbjsSk = this.sbjData.sbjs.filter(v => (v.nm == e))
								this.formParameter.code = sbjsSk[0].code
								this.formParameter.tp = sbjsSk[0].type
								if (this.sbjData.school[0]) {
									this.formParameter.school = this.sbjData.school[0].nm
									this.formParameter.skcode = this.sbjData.school[0].code
								}
							}
						}
					}
				}
			})


		},
		validID(rule, value, callback) {
			// 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
			let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
			if (reg.test(value)) {
				this.stuByKey(value.length);
				callback();
			} else {
				callback(new Error("身份证号码不正确"));
			}
		},
		validDh(rule, value, callback) {
			let dh = /^[1-9]\d{10}$/;
			if (dh.test(value)) {
				this.stuByKey(value.length);
				callback();
			} else {
				callback(new Error("手机号码不正确"));
			}
		},
		stuByKey(e) {
			if (e == 18 || e == 11) {
				if (e == 18) {
					this.key = this.formParameter.idno
				} else if (e == 11) {
					this.key = this.formParameter.moblie
				}
				let param = { key: this.key }
				api.stuByKey(param, (response) => {

					if (this.formParameter.moblie) {
						this.formParameter.idno = response.data.idno
					} else {
						this.formParameter.moblie = response.data.moblie
					}

					if (response.data.tjr) {
						this.formParameter.tjrName = response.data.tjr
						this.formParameter.tjrid = response.data.id
					}
					this.formParameter.name = response.data.name
					this.formParameter.mz = response.data.mz
					this.formParameter.stuid = response.data.id
					if (response.data.sex == 1) {
						this.formParameter.sex = '男'
					} else {
						this.formParameter.sex = '女'
					}
					setTimeout(this.$forceUpdate(), 10);
				});
			}
		},
		//打开弹框
		open(parameter, title, disabled, size) {
			this.parameter = parameter;

			this.disabled = disabled;
			this.$refs.popup.open(title, "2000");
			this.$nextTick(() => {
				this.init();
			})
		},

		//关闭弹框
		close() {
			this.disabled = false;
			this.$refs.popup.close();
		},
		//提交表单
		confirm() {

		    this.confirmLoading = true;
			   if (!this.parameter.id) {
				//添加
				this.$utils.confirm.warning("提示", "请确定添加数据吗?", () => {
					let parameter = this.$utils.merger(this.formParameter);
					signupApi.save(parameter,
						response => {
							this.$utils.msg.success(response.msg);
							this.confirmLoading = false;
							this.close();
							this.$parent.list();
						},
						response => {
							this.$utils.msg.warning(response.msg);
							this.confirmLoading = false;
						}
					);
				})
			} else {
				//编辑
				this.$utils.confirm.warning("提示", "确定修改数据吗?", () => {
					let parameter = this.$utils.merger(this.formParameter);
					signupApi.update(parameter,
						response => {
							this.$utils.msg.success(response.msg);
							this.confirmLoading = false;
							this.close();
							this.$parent.list();
						},
						response => {
							this.$utils.msg.warning(response.msg);
							this.confirmLoading = false;
						}
					);
				})
			} 
		},
		init() {
			this.popupLoading = true;
			//清除等待
			this.confirmLoading = false;
			//清空内容
			this.formParameter = {};
			//清楚校验
			this.$refs.form.clearValidate();

			if (this.parameter.id) {
				//编辑查询数据
				let parameter = {
					id: this.parameter.id
				};
				signupApi.toUpdate(parameter, response => {

					this.formParameter = response.data;
					let parameters = {
						key: this.parameter.key
					}
					api.stuByKey(parameters, response => {
						//合并以电话号码获取的身份信息数据
						this.formParameter = Object.assign(response.data, this.formParameter);
						if (this.formParameter.sex == 1) {
							this.formParameter.sex = '男'
						} else {
							this.formParameter.sex = '女'
						}

					})
					this.popupLoading = false;
					api.cascadeSub({}, (responsea) => {
						// 通过vue的双向绑定渲染数据
						this.sbjData = responsea.data;
					})
				});

			} else if (!this.parameter.id) {
				//添加
				this.popupLoading = false;
				this.getSubject();
			}
			
		}
	},
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
@import '~common/custom/css/popup/popup.scss';
</style>
